import { compose } from 'redux';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import { firestoreConnect } from 'react-redux-firebase';
import PlayersAdmin from '../components/players/PlayersAdmin';

const mapStateToProps = (state, ownProps) => {
    const id = ownProps.match.params.id;
    return {
        players: state.firestoreData.ordered.gamePlayers,
        player: state.player ? state.player.data : state.player,
        id: id
    }
}

const PlayersAdminContainer =  withRouter(compose(
    connect(mapStateToProps),
    firestoreConnect((props) => ([
        { 
            collection: 'games' ,
            doc: props.id,
            subcollections: [{ collection: 'players' }],
            storeAs: 'gamePlayers'
        }
      ]))
)(PlayersAdmin));

export default PlayersAdminContainer;